export default "__VITE_ASSET__D3mkVV____"